<template>
  <div>
    <b-row class="align-items-center justify-content-between g-0">
      <b-container class="user-about mt-4">
        <b-form @submit.prevent="handleSubmit" @reset.prevent="handleReset" id="workDetailsForm" class="bg-white">
          <h4 class="text-info text-center font-weight-bolder mb-4">Edit Current Work Details</h4>
          <!-- Sticky Save & Cancel Buttons -->
          <b-form-group class="text-center sticky-top bg-white py-2">
            <b-button type="submit" variant="success" size="sm" :disabled="isSubmitting">
              {{ isSubmitting ? 'Please Wait...' : 'Save' }}
            </b-button>
            <b-button type="reset" variant="danger" size="sm" class="ml-2" :disabled="isSubmitting">
              Cancel
            </b-button>
          </b-form-group>

          <!-- Institution Name -->
          <b-form-group label="Institution Name" label-for="institution-name-input" label-cols-sm="3" label-align-sm="left"
            label-size="sm" class="mb-2">
            <b-form-input id="institution-name-input" v-model="userProfile.institute_name" size="sm"
              :class="{ 'is-invalid': responseErrors.institute_name }"></b-form-input>
            <b-form-invalid-feedback v-if="responseErrors.institute_name">{{ responseErrors.institute_name[0] }}</b-form-invalid-feedback>
          </b-form-group>

          <!-- Contract Type -->
          <b-form-group label="Contract Type" label-for="contract-type-input" label-cols-sm="3" label-align-sm="left"
            label-size="sm" class="mb-2">
            <b-form-input id="contract-type-input" v-model="userProfile.contract_type" size="sm"
              :class="{ 'is-invalid': responseErrors.contract_type }"></b-form-input>
            <b-form-invalid-feedback v-if="responseErrors.contract_type">{{ responseErrors.contract_type[0] }}</b-form-invalid-feedback>
          </b-form-group>

          <!-- Department -->
          <b-form-group label="Department" label-for="department-input" label-cols-sm="3" label-align-sm="left"
            label-size="sm" class="mb-2">
            <b-form-input id="department-input" v-model="userProfile.department_name" size="sm"
              :class="{ 'is-invalid': responseErrors.department_name }"></b-form-input>
            <b-form-invalid-feedback v-if="responseErrors.department_name">{{ responseErrors.department_name[0] }}</b-form-invalid-feedback>
          </b-form-group>

          <!-- Designation -->
          <b-form-group label="Designation" label-for="designation-input" label-cols-sm="3" label-align-sm="left"
            label-size="sm" class="mb-2">
            <b-form-input id="designation-input" v-model="userProfile.designation" size="sm"
              :class="{ 'is-invalid': responseErrors.designation }"></b-form-input>
            <b-form-invalid-feedback v-if="responseErrors.designation">{{ responseErrors.designation[0] }}</b-form-invalid-feedback>
          </b-form-group>

          <!-- Staff ID -->
          <b-form-group label="Staff ID" label-for="staff-id-input" label-cols-sm="3" label-align-sm="left"
            label-size="sm" class="mb-2">
            <b-form-input id="staff-id-input" v-model="userProfile.staff_id" size="sm"
              :class="{ 'is-invalid': responseErrors.staff_id }"></b-form-input>
            <b-form-invalid-feedback v-if="responseErrors.staff_id">{{ responseErrors.staff_id[0] }}</b-form-invalid-feedback>
          </b-form-group>
          
        </b-form>
      </b-container>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    profile: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      userProfile: { ...this.profile },
      responseErrors: {},
      isSubmitting: false,
    };
  },
  methods: {
    async handleSubmit() {
      this.isSubmitting = true;
      try {
        await this.$store.dispatch('storeUserProfile', this.userProfile);
        this.$toast.success('Profile Updated', { position: 'top', duration: 3000 });
        this.$emit('profileCancelled');
        this.$emit("profileUpdated");
      } catch (error) {
        this.responseErrors = error.response.data.errors || {};
      } finally {
        this.isSubmitting = false;
      }
    },
    handleReset() {
      this.userProfile = { ...this.profile };
      this.responseErrors = {};
      this.$emit('profileCancelled');
    },
  },
};
</script>

<style scoped>
.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1000;
  border-bottom: 1px solid #ddd;
}
</style>
